/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { MODAL_TRANSITION_DURATION, MODAL_Z_INDEX } from './tokens';
import { CFStyleThemes } from '../../theme';
//
// Tokens
//
export const CFBaseModalSkinTokens = {
    BORDER_RADIUS: CFTokens.BORDER_RADIUS.D,
    SHADOW: CFTokens.ELEVATION.B,
    SIZE: {
        lg: 880,
        md: 640,
        sm: 480,
    },
};
//
// Helpers
//
export const CFBaseModalSkinHelpers = {
    rootHeightWeb: ({ skin }) => css `
    height: ${skin === 'full-screen' ? '100%' : 'auto'};
  `,
    rootPadding: ({ footerSafeGap, headerSafeGap, skin, }) => {
        let bpad = 0, lrpad = 0, tpad = CFTokens.SPACER.D + Number(headerSafeGap || 0);
        switch (skin) {
            case 'pop-tart':
            case 'pop':
                bpad = CFTokens.SPACER.D + Number(footerSafeGap || 0);
                lrpad = CFTokens.SPACER.D;
                tpad = CFTokens.SPACER.D + Number(headerSafeGap || 0);
                break;
            case 'full-screen':
                tpad = 0;
                lrpad = 0;
                bpad = 0;
                break;
            case 'bottom-sheet':
            default:
                tpad = CFTokens.SPACER.D + Number(headerSafeGap || 0);
                lrpad = 0;
                bpad = 0;
                break;
        }
        return css `
      padding: ${tpad}px ${lrpad}px ${bpad}px;
    `;
    },
    rootSelfAlignWeb: ({ skin }) => {
        if (skin === 'pop') {
            return css `
        align-self: center;
      `;
        }
        return css `
      align-self: flex-end;
    `;
    },
    rootWidth: ({ size, skin }) => {
        if (skin === 'full-screen') {
            return css `
        width: 100%;
      `;
        }
        const maxWidth = CFBaseModalSkinTokens.SIZE[size];
        return css `
      width: 100%;
      max-width: ${maxWidth}px;
    `;
    },
    sheetBackgroundColor: ({ alternateTheme, theme, }) => {
        if (alternateTheme) {
            return theme
                ? theme.COLOR.MODAL_BACKGROUND_ALTERNATE
                : CFStyleThemes.DEFAULT.COLOR.MODAL_BACKGROUND_ALTERNATE;
        }
        return theme
            ? theme.COLOR.MODAL_BACKGROUND
            : CFStyleThemes.DEFAULT.COLOR.MODAL_BACKGROUND;
    },
    sheetBorderRadius: ({ skin }) => {
        switch (skin) {
            case 'full-screen':
                return null; // No border radius on full screen skin
            case 'bottom-sheet':
                return css `
          border-top-left-radius: ${CFBaseModalSkinTokens.BORDER_RADIUS}px;
          border-top-right-radius: ${CFBaseModalSkinTokens.BORDER_RADIUS}px;
        `;
            case 'pop':
            case 'pop-tart':
            default:
                return css `
          border-radius: ${CFBaseModalSkinTokens.BORDER_RADIUS}px;
        `;
        }
    },
    sheetPadding: ({ footerSafeGap, headerSafeGap, skin, }) => {
        let bpad, tpad;
        switch (skin) {
            case 'full-screen':
                bpad = footerSafeGap || CFTokens.SPACER.D;
                tpad = headerSafeGap || CFTokens.SPACER.D;
                break;
            case 'pop-tart':
                bpad = CFTokens.SPACER.E;
                tpad = CFTokens.SPACER.B;
                break;
            case 'pop':
                bpad = CFTokens.SPACER.E;
                tpad = CFTokens.SPACER.D;
                break;
            case 'bottom-sheet':
            default:
                bpad = footerSafeGap || CFTokens.SPACER.B;
                tpad = CFTokens.SPACER.B;
                break;
        }
        return css `
      padding: ${tpad}px 0 ${bpad}px;
    `;
    },
};
//
// Element Styles
//
export const CFBaseModalSkinStyles = {
    Root: css `
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    z-index: ${MODAL_Z_INDEX};
    position: relative;
    border: 0;
    background: transparent;
    ${CFBaseModalSkinHelpers.rootPadding};
    ${CFBaseModalSkinHelpers.rootWidth}
  `,
    RootWeb: css `
    max-height: 100%;
    overflow: hidden;
    transition-timing-function: ease-in-out;
    transition-duration: ${MODAL_TRANSITION_DURATION}ms;
    transition-property: padding, max-width, width, height;
    ${CFBaseModalSkinHelpers.rootHeightWeb};
    ${CFBaseModalSkinHelpers.rootSelfAlignWeb}
  `,
    Sheet: css `
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
    position: relative;
    background-color: ${CFBaseModalSkinHelpers.sheetBackgroundColor};
    box-shadow: ${CFBaseModalSkinTokens.SHADOW};
    ${CFBaseModalSkinHelpers.sheetBorderRadius};
    ${CFBaseModalSkinHelpers.sheetPadding};
  `,
    SheetWeb: css `
    overflow: hidden;
    transition-timing-function: ease-in-out;
    transition-duration: ${MODAL_TRANSITION_DURATION}ms;
    transition-property: padding, border-radius, width, height, background-color;
  `,
};
